module.exports = __webpack_public_path__ + "img/hr-dry-tree-05.ac58650b.png";